import commonFun from "@/utils/commonFun";

export default {
    data() {
    },
    computed: {
        isSupplier() {
            return commonFun.isSupplier();
        },
        uploadHeader() {
            return {'x-access-token': localStorage.getItem('token')};
        }
    },
    methods:{
        /**
         * @param {string} tips 提示信息
         * @param {*} 标题
         * @param {*} 确认按钮
         * @param {*} 取消按钮
         * @param {*} 其他参数
         */
        confirm(tips,title,confirmButton,cancelButton,options){
            title = commonFun.isEmpty(title) ? this.$t("common.tips") : title;
            options = commonFun.isEmpty(options) ? {} : options;
            confirmButton = commonFun.isEmpty(confirmButton) ? this.$t('common.confirm') : confirmButton;
            cancelButton = commonFun.isEmpty(cancelButton) ? this.$t('common.cancel') : cancelButton;
            options.confirmButtonText = confirmButton;
            options.cancelButtonText = cancelButton;
            options.distinguishCancelAndClose = true;
            return this.$confirm(tips, title, options);
        },
        prompt(tips,title,confirmButton,cancelButton,options){
            title = commonFun.isEmpty(title) ? this.$t("common.tips") : title;
            options = (typeof options == "undefined")? {} : options;
            confirmButton = commonFun.isEmpty(confirmButton) ? this.$t('common.confirm') : confirmButton;
            cancelButton = commonFun.isEmpty(cancelButton) ? this.$t('common.cancel') : cancelButton;
            options.confirmButtonText = confirmButton;
            options.cancelButtonText = cancelButton;
            return this.$prompt(tips, title, options);
        },
        dispatchFormValide(value) {
            this.dispatch('ElFormItem', 'el.form.change', value);
            this.dispatch('ElFormItem', 'el.form.blur', value);
        },
        dispatch(componentName, eventName, params) {
            var parent = this.$parent || this.$root;
            var name = parent.$options.componentName;
            // 从这里可以看出是找到对应的组件对象
            while (parent && (!name || name !== componentName)) {
                parent = parent.$parent;
                if (parent) {
                    name = parent.$options.componentName;
                }
            }
            if (parent) {
                parent.$emit.apply(parent, [eventName].concat(params));
            }
        },
        /* 公共的确认框 */
        callConfirm(option = {msg: null,title: null}) {
            return this.$confirm(option.msg || this.$t('common.delConfirm'), option.title || this.$t('common.tips'), {
                confirmButtonText: this.$t('common.confirm'),
                cancelButtonText: this.$t('common.cancel'),
                type: option.type || 'warning'
            }).then(() => true)
                .catch(() => false)
        },
        /*
         *   关闭弹窗
         * */
        cancel(dialog) {
            // 重置数据
            if (this.$refs['createParams']) {
                this.$refs['createParams'].resetFields()
            }
            this.$emit('hideDialog', dialog)
        },
        routerBack() {
            this.$router.back()
        },
    }
}
